import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Pillar, { PillarProps } from '@/components/base/Pillar'

import { pillarsGridRevealAnimation } from './animations'
import { Section } from '@/types'

type PillarsGridProps = Section & {
  collection?: PillarProps[]
}

const PillarsGrid = ({ collection, ...props }: PillarsGridProps) => {
  return (
    <Motion animation={pillarsGridRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-xs md:gap-y-sm">
              {collection?.map((pillar) => (
                <div
                  key={`pillar-${pillar.uuid}`}
                  className="col-span-2 sm:col-span-1 md:col-span-2 lg:col-span-3"
                >
                  <Pillar {...pillar} />
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default PillarsGrid
